<app-step-navigation></app-step-navigation>

<div [@routeAnimations]="prepareRoute()" class="step-content-wrapper" #stepWrapper [style.min-height]="componentHeight + 'px'">
  <router-outlet></router-outlet>
</div>
